import Siprec from './factory/Siprec'
import Locale from '@/locale'

export default Siprec({
  name: 'companyNotifications',
  enums: {
    severity: {
      'DEBUG': Locale.t('companyNotifications.severity.debug'),
      'INFO': Locale.t('companyNotifications.severity.info'),
      'WARN': Locale.t('companyNotifications.severity.warn'),
      'ERROR': Locale.t('companyNotifications.severity.error')
    },
    type: {
      'AUTOMATIC_TARGET': Locale.t('companyNotifications.type.automaticTarget'),
      'QUOTA_USAGE': Locale.t('companyNotifications.type.quotaUsage')
    }
  }
})



// WEBPACK FOOTER //
// ./src/models/CompanyNotification.js